import { render, staticRenderFns } from "./contactAdmin.vue?vue&type=template&id=7242f032&"
import script from "./contactAdmin.vue?vue&type=script&lang=js&"
export * from "./contactAdmin.vue?vue&type=script&lang=js&"
import style0 from "./contactAdmin.vue?vue&type=style&index=0&id=7242f032&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports